import Services from "../components/main-pages/Services";
import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import HreflangLinks from "../components/common/HrefLinkTags";
import { fetchParentServicesData } from "../components/http/commonApi";

export default function ServicesPage({ services }) {
  const { t } = useTranslation("services");
  const { locale } = useRouter();
  return (
    <>
      <HreflangLinks enPath="/services" arPath="/ar/services" />
      <Head>
        <title>{t("services.seo.metaTitle")}</title>
        <meta name="description" content={t("services.seo.metaDescription")} />
        {locale === "ar" ? (
          <link
            rel="canonical"
            href={`https://www.prism-me.com/${locale}/services`}
          />
        ) : (
          <link rel="canonical" href="https://www.prism-me.com/services" />
        )}
      </Head>
      <Services services={services} />
    </>
  );
}

export async function getServerSideProps({ locale }) {
  try {
    const { data: services } = await fetchParentServicesData(locale);

    return {
      props: {
        services: services?.data ?? [],
        ...(await serverSideTranslations(locale, [
          "header",
          "footer",
          "services",
          "common",
        ])),
      },
    };
  } catch (error) {
    console.error("Error fetching services:", error);
    return {
      props: {
        services: [],
        ...(await serverSideTranslations(locale, [
          "header",
          "footer",
          "services",
          "common",
        ])),
      },
    };
  }
}
